/* eslint-disable react/prop-types */
import React from 'react';
import {
  STestimonialCard,
  STestimonialCardFooter,
  STestimonialAuthor,
  STestimonialItem,
  STestimonialPosition,
  STestimonialText,
  STestimonialRow,
  STestimonialImageStar,
} from './styles';
import PropTypes from 'prop-types';
import TrustPilotStarsSVG from 'images/svg/trust_pilot_stars.svg';

const TestimonialCard = ({ text, author, image, asA }) => (
  <STestimonialCard>
    <STestimonialItem>
      <STestimonialText>{text}</STestimonialText>
    </STestimonialItem>
    <STestimonialCardFooter>
      {/* <STestimonialImage filename={image} /> */}
      <STestimonialImageStar>
        <TrustPilotStarsSVG />
      </STestimonialImageStar>
      <STestimonialAuthor>{author}</STestimonialAuthor>
      <STestimonialPosition>{asA}</STestimonialPosition>
    </STestimonialCardFooter>
  </STestimonialCard>
);

const TestimonialsSlider = ({ testimonials }) => {
  return (
    <STestimonialRow>
      {testimonials.map((val, idx) => (
        <TestimonialCard
          key={idx}
          text={val.text}
          author={val.author}
          image={val.image}
          asA={val.as}
        />
      ))}
    </STestimonialRow>
  );
};

TestimonialsSlider.propTypes = {
  testimonials: PropTypes.array,
};

export default TestimonialsSlider;
